import { countExecutionStatuses, type SuiteRunDto } from '@flowqa/shared';

export const resolveSuiteRunTestCounts = (
  row: SuiteRunDto,
): {
  passed: number;
  failed: number;
  errored: number;
  skipped: number;
  untested: number;
} => {
  if (Array.isArray(row.testRunSummaries) && row.testRunSummaries.length > 0) {
    const counts = countExecutionStatuses(row.testRunSummaries.map((summary) => summary.status));
    return {
      passed: counts.passed,
      failed: counts.failed,
      errored: counts.errored,
      skipped: counts.skipped,
      untested: counts.untested,
    };
  }
  const total = row.tests ?? 0;
  const failed = row.failures ?? 0;
  const errored = row.errors ?? 0;
  const skipped = row.skipped ?? 0;
  const untested = row.status === 'untested' ? Math.max(total - failed - errored - skipped, 0) : 0;
  const passed = Math.max(total - failed - errored - skipped - untested, 0);
  return { passed, failed, errored, skipped, untested };
};
